import { render, staticRenderFns } from "./GestaoCadastros.vue?vue&type=template&id=1fee3480"
import script from "./GestaoCadastros.vue?vue&type=script&lang=js"
export * from "./GestaoCadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports